import React, { Suspense } from 'react';
import ErrorBoundary from 'common/components/error-boundary';
import { PREPARER, SENDER } from 'hellospa/components/signature-request';
import EditorContext from './context';
import {
  FEATURE_TEMPLATE_ROLES, FEATURE_DATE_FORMAT,
  FEATURE_SENDER_ASSIGN, addFeature, removeFeature, FEATURE_EMBED,
  FEATURE_PHASE_3, hasFeature, featureMap,
  FEATURE_CAN_ADD_SIGNER, FEATURE_EDIT_SIGNERS, FEATURE_EDIT_DOCUMENTS,
  FEATURE_ROTATE_PAGES, FEATURE_DROPDOWN,
  FEATURE_RADIO, FEATURE_CONDITIONAL_LOGIC, FEATURE_SIGNATURE_COLOR,
  FEATURE_HYPERLINKS, FEATURE_CONDITIONAL_LOGIC_NESTED, FEATURE_MASKED_FIELDS,
  FEATURE_TEMPLATE_ONE_OFF_FILE, FEATURE_AUTOFILL_FIELDS, FEATURE_PREVIEW,
} from './constants';


const EditorLayout = React.lazy(() => import(/* webpackChunkName: "hellospa-editor2" */'./editor-layout'));
const EditorV1 = React.lazy(() => import(/* webpackChunkName: "hellospa-editor1" */'./editor-v1'));


// It's a little unusual to use bitwise operators in JavaScript, but they fit
// this purpose very well. Instead of globally disabling the rule I added a
// `hasFeature` helper function.
/* eslint-disable no-bitwise */

// These MODE_ constants are just bundles of common features. If you have a new
// requirement that templates must do something, you probably want a new
// `FEATURE_` and to add it here. If the feature is applied based on some other
// criteria, make a new FEATURE_ and merge it into the appropriate mode with
// `addFeature(mode, FEATURE_MY_NEWFEATURE)` in
// src/hellospa/page/editor/index.jsx
export const MODE_EDIT = (
  FEATURE_EDIT_SIGNERS | FEATURE_CAN_ADD_SIGNER | FEATURE_EDIT_DOCUMENTS
);
export const MODE_EDIT_TEMPLATE = (
  FEATURE_TEMPLATE_ROLES | FEATURE_SENDER_ASSIGN | FEATURE_EDIT_SIGNERS
  | FEATURE_CAN_ADD_SIGNER | FEATURE_EDIT_DOCUMENTS
);
export const MODE_EDIT_TEMPLATE_LINK = FEATURE_TEMPLATE_ROLES;
/* eslint-enable no-bitwise */


export {
  PREPARER, SENDER, FEATURE_EMBED, FEATURE_DATE_FORMAT,
  FEATURE_PHASE_3, addFeature, removeFeature, hasFeature, featureMap,
  FEATURE_CAN_ADD_SIGNER, FEATURE_EDIT_SIGNERS, FEATURE_EDIT_DOCUMENTS,
  FEATURE_ROTATE_PAGES, FEATURE_DROPDOWN, FEATURE_RADIO, FEATURE_CONDITIONAL_LOGIC,
  FEATURE_SIGNATURE_COLOR, FEATURE_HYPERLINKS, FEATURE_CONDITIONAL_LOGIC_NESTED,
  FEATURE_MASKED_FIELDS, FEATURE_SENDER_ASSIGN, FEATURE_TEMPLATE_ONE_OFF_FILE,
  FEATURE_TEMPLATE_ROLES, FEATURE_AUTOFILL_FIELDS, FEATURE_PREVIEW,
};

function Editor(props) {
  return (
    <EditorContext {...props}>
      <Suspense fallback="">
        {hasFeature(props.mode, FEATURE_PHASE_3)
          ? <EditorLayout />
          : <EditorV1 />
        }

      </Suspense>
    </EditorContext>
  );
}


export default function EditorWithErrorBoundary(props) {
  return <ErrorBoundary><Editor {...props} /></ErrorBoundary>;
}
